import PageProtected from "../../components/Page/PageProtected";
import SectionDashboard from "../../components/Section/SectionDashboard";
import SectionBooking from "./BookSession/SectionBooking";
import { useTheme } from "@mui/material";

export default function DoctorWelcome() {
   
const theme = useTheme();

    return (
    <>
    
    <PageProtected
    
            headline="Book your "
            specify="counseling session"
            main={<>
 
 
        {theme.palette.mode === "light" ? (

        <SectionDashboard

            colorContainer="transparent"

            colorSection_1="grey.C400"
            Section_1={<SectionBooking />}

            colorSection_2="grey.C400"
            Section_2={  "" }
            
            colorSection_3="grey.C500"
            Section_3= {""} 

            colorSection_4="grey.C200"
            Section_4={ "" }

        />

):(

    <SectionDashboard

            colorContainer="transparent"

            colorSection_1="secondarydark.C100"
            Section_1={<SectionBooking />}

            colorSection_2="secondarydark.C300"
            Section_2={ "" }
            
            colorSection_3="greydark.C500"
            Section_3= { ""}  

            colorSection_4="greydark.C500"
            Section_4={ "" }

        />
        )}
    </>
    }
/>

</>
)
}